module.exports = __webpack_public_path__ + "img/close-1.dde41a98.svg";